// =============================================================
// GSB custom JS
// Voraussetzung: window.onCalendarPage und window.calendarURLInit
// werden als globale Variablen aus PHP geliefert (index.php).
// =============================================================

const body = document.body;
const mqMin320 = window.matchMedia("(min-width: 320px)");
const mqMin993 = window.matchMedia("(min-width: 993px)");

const btnMenu = document.querySelector("#btn_menu");
const btnSearchOpen = document.querySelector("#btn_search_open");
const btnSearchClose = document.querySelector("#btn_search_close");
const inputSearch = document.querySelector("#searchbox input[name='q']");
const calendarLink = document.querySelector("#calendarLink");

// ======================================================
// KALENDER-LINK
// Screenbreite >=993px zeige Monatsansicht, sonst Mobile
// ======================================================

function setCalendarURL() {
  // Auf der Kalenderseite selbst nicht umschreiben. onCalendarPage kommt
  // als globale Variable aus der index.php und fehlt dort, wo sie nicht
  // gesetzt wird.
  if (typeof onCalendarPage !== "undefined" && onCalendarPage) return;

  calendarLink.href = mqMin993.matches
    ? "/aktuelles/termine-kalender-monat.html"
    : "/aktuelles/termine-kalender-jahr.html";
}

setCalendarURL();

// =============================================================
// HOME-LINK
// Wenn Startseite aktiv: href und title auf "#" / "nach oben"
// setzen, damit kein Reload ausgelöst wird.
// =============================================================

const homeItem = document.querySelector(".item-home");
const homeLinks = document.querySelectorAll(".homepage");

if (homeItem?.classList.contains("active")) {
  homeLinks.forEach((el) => {
    const a = el.querySelector("a");
    if (!a) return;
    a.href = "#";
    a.title = "nach oben";
  });
}

// =============================================================
// MENÜ & SUCHE
//
// Je ein einziger click- und keydown-Listener auf document. Die
// Untermenüs gehören menu.js; von hier aus werden sie nur über
// window.gsbMenu zugeklappt.
//
// Die vier Zustandswechsel stehen in eigenen Funktionen, damit
// aria-expanded, aria-label und title nicht an mehreren Stellen
// getrennt nachgezogen werden müssen.
// =============================================================

function openMobileMenu() {
  body.classList.add("menu--open");
  btnMenu?.setAttribute("aria-expanded", "true");
  btnMenu?.setAttribute("aria-label", "Menü schließen");
  btnMenu?.setAttribute("title", "Menü schließen");
  window.gsbMenu?.closeSubmenus();
}

function closeMobileMenu() {
  body.classList.remove("menu--open");
  btnMenu?.removeAttribute("aria-expanded");
  btnMenu?.setAttribute("aria-label", "Menü öffnen");
  btnMenu?.setAttribute("title", "Menü öffnen");
  window.gsbMenu?.closeSubmenus();
}

function openSearch() {
  body.classList.add("search--open");

  // Zwei Frames warten: davor ist das Feld noch ausgeblendet und
  // nimmt den Fokus nicht an.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => inputSearch?.focus());
  });
}

function closeSearch() {
  body.classList.remove("search--open");
}

document.addEventListener("click", (e) => {
  const target = e.target;

  if (btnMenu?.contains(target)) {
    if (body.classList.contains("menu--open")) {
      closeMobileMenu();
    } else {
      closeSearch();
      openMobileMenu();
    }
    return;
  }

  if (btnSearchOpen?.contains(target)) {
    closeMobileMenu();
    openSearch();
    return;
  }

  if (btnSearchClose?.contains(target)) {
    closeSearch();
    window.gsbMenu?.closeSubmenus();
    return;
  }

  // Klick außerhalb des Hauptmenüs: mobiles Menü und Untermenüs zu.
  if (!target.closest(".main-menu")) {
    closeMobileMenu();
  }
});

// =============================================================
// ESCAPE
// Schließt der Reihe nach: mobiles Menü, Suche, offenes Untermenü.
// Der Fokus geht jeweils auf das auslösende Element zurück, statt
// verloren zu gehen.
// =============================================================

document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;

  if (body.classList.contains("menu--open")) {
    closeMobileMenu();
    btnMenu?.focus();
    return;
  }

  if (body.classList.contains("search--open")) {
    closeSearch();
    btnSearchOpen?.focus();
    return;
  }

  window.gsbMenu?.closeSubmenus()?.focus();
});

// =============================================================
// RESIZE – debounced
// =============================================================

let resizeTimer;

window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (mqMin993.matches) {
      closeMobileMenu();
    }
    setCalendarURL();
  }, 100);
});

// =============================================================
// SCROLL
// Klasse "scroll" ab 100px Scrolltiefe – nur ab 320px Breite
// =============================================================

function onScroll() {
  const scrolled =
    document.documentElement.scrollTop > 100 || document.body.scrollTop > 100;
  body.classList.toggle("scroll", scrolled);
}

if (mqMin320.matches) {
  window.addEventListener("scroll", onScroll, { passive: true });
}

// =============================================================
// SLIDER
// =============================================================

class Slider {
  constructor(el) {
    this.el = el;
    this.id = el.id;
    this.pictures = [...el.getElementsByClassName("pictures")];
    this.dots = [...el.getElementsByClassName("dot")];
    this.index = 1;
    this.direction = "animateFromRight";
    this._init();
  }

  _init() {
    this.pictures.forEach((p) => (p.style.display = "none"));
    this.dots.forEach((d) => d.classList.remove("activeImage"));
    this.pictures[0].style.display = "block";
    this.pictures[0].classList.add("animateFromRight");
    this.dots[0].classList.add("activeImage");
  }

  _clamp(n) {
    if (n > this.pictures.length) return 1;
    if (n < 1) return this.pictures.length;
    return n;
  }

  _render() {
    this.pictures.forEach((p) => {
      p.style.display = "none";
      p.classList.remove("animateFromRight", "animateFromLeft");
    });
    this.dots.forEach((d) => d.classList.remove("activeImage"));

    const current = this.pictures[this.index - 1];
    current.style.display = "block";
    current.classList.add(this.direction);
    this.dots[this.index - 1].classList.add("activeImage");
  }

  step(n) {
    this.direction = n === -1 ? "animateFromLeft" : "animateFromRight";
    this.index = this._clamp(this.index + n);
    this._render();
  }

  goTo(n) {
    if (n === this.index) return;
    this.direction = n > this.index ? "animateFromRight" : "animateFromLeft";
    this.index = n;
    this._render();
  }
}

const sliders = new Map();

document.querySelectorAll(".slider[id]").forEach((el) => {
  sliders.set(el.id, new Slider(el));
});

// Globale Hilfsfunktionen – werden per onclick im HTML aufgerufen
function backfor(callingEl, n) {
  const id = callingEl.closest("[id]")?.id;
  sliders.get(id)?.step(n);
}

function directImgChoice(callingEl, n) {
  const id = callingEl.closest("[id]")?.id;
  sliders.get(id)?.goTo(n);
}

window.backfor = backfor;
window.directImgChoice = directImgChoice;

// =============================================================
// ELLIPSIS vor read-more-Buttons
// =============================================================

document.querySelectorAll(".readmore").forEach((el) => {
  el.previousElementSibling?.classList.add("ellipsi");
});
